// Module
var code = `<breadcrumbs></breadcrumbs>
<gl-header>
  <div class="info__column">
      <span class="info__field" ng-repeat="entry in \$ctrl.header">
        <span class="info__field-label">{{entry.label}}:</span>
        <span class="info__field-value">{{entry.text}}</span>
      </span>
  </div>
</gl-header>
<section class="box">
  <sub-header header="'Create interbranch GL transaction'"></sub-header>
    <form name="\$ctrl.createTransactionForm" class="transaction-create-form" novalidate>
      <table class="table table--generate-row-ids transaction-create-form-table" ng-if="\$ctrl.mode == 'CREATE'">
        <tbody>
          <tr>
            <td></td>
            <td>Mode:</td>
            <td>
              <select ng-options="type.value as type.label for type in \$ctrl.glTransactionInputMode"
                      ng-model="\$ctrl.inputMode"
                      ng-change="\$ctrl.inputModeChanged(\$ctrl.inputMode, '{{\$ctrl.inputMode}}')"
                      required>
              </select>
            </td>
          </tr>
          <tr ng-if="\$ctrl.inputMode === 'MANUAL'">
            <td></td>
            <td>Use categories:</td>
            <td>
              <select
                  ng-model="\$ctrl.useCategories"
                  ng-change="\$ctrl.resetForm()"
                  boolean-options
                  required>
              </select>
            </td>
          </tr>
          <validator condition="\$ctrl.postingDateValid"></validator>
          <tr ng-if="\$ctrl.backdated">
            <td></td>
            <td>Posting date:</td>
            <td>
              <date ng-required="true"
                    ng-model="\$ctrl.backdatedPostingDate"
                    ng-class="{'nx-invalid': !\$ctrl.postingDateValid}"
                    ng-change="\$ctrl.validatePostingDate()"
                    min="\$ctrl.minBackdatedPostingDate"
                    max="\$ctrl.maxBackdatedPostingDate">
              </date>
            </td>
          </tr>
          <tr ng-if="\$ctrl.useCategories">
            <td></td>
            <td>Source branch category:</td>
            <td>
              <gl-category-select
                  action-type="'MANUAL_INTERBRANCH_TICKET_SOURCE'"
                  single-accounts-only="false"
                  ng-model="\$ctrl.sourceBranchCategory"
                  ng-change="\$ctrl.sourceBranchCategoryChanged()"
                  is-selectize="true"
              >
              </gl-category-select>
            </td>
          </tr>
          <tr ng-if="\$ctrl.useCategories">
            <td></td>
            <td>Target category:</td>
            <td>
              <gl-category-select
                  action-type="'MANUAL_INTERBRANCH_TICKET_TARGET'"
                  single-accounts-only="false"
                  ng-model="\$ctrl.targetBranchCategory"
                  ng-change="\$ctrl.targetBranchCategoryChanged()"
                  is-selectize="true"
              >
              </gl-category-select>
            </td>
          </tr>
          <tr ng-if="\$ctrl.inputMode === 'BATCH'">
            <td></td>
            <td>File:</td>
            <td>
              <file-upload ng-model="\$ctrl.contentFile"
                           required
                           validate-uploaded
                           max-files="1"
                           show-file-name="true"
                           show-remarks="false"
                           enable-webcam="false"
                           validate='{pattern: ".csv,*.txt"}'>
              </file-upload>
            </td>
          </tr>
        </tbody>
        <tfoot ng-if="\$ctrl.inputMode === 'BATCH'">
          <tr>
            <td></td>
            <td></td>
            <td>
              <button
                type="button"
                class="btn btn-info"
                ng-click="\$ctrl.downloadSampleFile()">
                Download sample file
              </button>
              <button
                type="submit"
                class="btn btn-success"
                ng-disabled="!\$ctrl.simulateButtonEnabled()"
                ng-click="\$ctrl.simulate()">
                Simulate
              </button>
            </td>
          </tr>
        </tfoot>
      </table>

      <div class="alerts">
        <div class="alert alert--danger" ng-if="\$ctrl.mode == 'CREATE' && !\$ctrl.isInterbranchTransactionBalancedOnCreate()">
          Interbranch transaction is not balanced.
        </div>
        <div class="alert alert--danger" ng-if="\$ctrl.mode === 'EDIT' && !\$ctrl.areAllLedgerTransactionsBalanced()">
          Transaction units in every branch must be balanced.
        </div>
        <div class="alert alert--danger" ng-if="!\$ctrl.postingDateValid">
          <strong>Warning!</strong> Posting date must be a working day in all transacting branches.
        </div>
        <div class="alert alert--danger" ng-if="!\$ctrl.isSourceBranchIncluded()">
          There are no transactions on source branch.
        </div>
        <div class="alert alert--danger" ng-if="!\$ctrl.hasNonZeroTotalAmounts()">
          At least one non-zero operation is needed for debit and credit.
        </div>
        <div class="alert alert--danger" ng-if="\$ctrl.hasEmptyAmountsInOperation()">
          There is at least one operation without debit and credit amount.
        </div>
        <div class="alert alert--danger" ng-if="\$ctrl.invalidTargetWarningMessage()">
          {{\$ctrl.invalidTargetWarningMessage()}}
          {{\$ctrl.invalidTargetSolutionMessage()}}
        </div>
      </div>

      <table class="table table--last-column-to-right transaction-create-table">
        <thead>
        <tr>
          <th class="no-column-header">No</th>
          <th class="home-column-header"></th>
          <th class="branch-column-header">Branch</th>
          <th class="account-column-header">Account</th>
          <th class="smaller-column-header">Debit amount</th>
          <th class="smaller-column-header">Credit amount</th>
          <th class="smaller-column-header">Remarks</th>
          <th ng-if="\$ctrl.inputMode === 'MANUAL'">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr ng-repeat="unit in \$ctrl.transactionUnits">
          <td>{{\$index + 1}}.</td>
          <td>
            <i ng-if="unit.branchId === \$ctrl.sourceBranchId"
               class="icon-home"></i>
          </td>
          <td ng-if="\$ctrl.mode === 'CREATE' && \$ctrl.useCategories && unit.branchId === \$ctrl.sourceBranchId">
            {{\$ctrl.getBranchLabel(unit.branchId)}}
          </td>
          <td ng-if="\$ctrl.mode === 'CREATE' && \$ctrl.useCategories && unit.branchId !== \$ctrl.sourceBranchId">
            <selectize
                class="nx-selectize"
                config="\$ctrl.selectizeConfig"
                options="\$ctrl.nonSourceBranches"
                ng-model="unit.branchId"
                ng-change="\$ctrl.validatePostingDate()"
                ng-required="true">
            </selectize>
          </td>
          <td ng-if="!\$ctrl.useCategories">
            <selectize
                class="nx-selectize"
                config="\$ctrl.selectizeConfig"
                options="\$ctrl.allBranches"
                ng-model="unit.branchId"
                ng-change="\$ctrl.validatePostingDate()"
                ng-required="true">
            </selectize>
          </td>
          <td>
            <field
                options="\$ctrl.glAccounts"
                field="fullCode"
                ng-model="unit.fullCode"
                transcluded-model="unit.account">
              <account-select options="\$ctrl.glAccounts"
                              ng-model="unit.account"
                              value-field="'id'"
                              required>
              </account-select>
            </field>
          </td>
          <td>
            <cash ng-model="unit.debitAmount"
                  ng-disabled="unit.creditAmount"
                  ng-change="\$ctrl.resetCreditAmount(unit)"
                  ng-required="true"></cash>
          </td>
          <td>
            <cash ng-model="unit.creditAmount"
                  ng-disabled="unit.debitAmount"
                  ng-change="\$ctrl.resetDebitAmount(unit)"
                  ng-required="true"></cash>
          </td>
          <td>
            <input type="text"
                   ng-model-options="{updateOn: 'blur'}"
                   ng-model="unit.remarks"
                   ng-required="true"/>
          </td>
          <td ng-if="\$ctrl.actionButtonsEnabled()">
            <button type="button"
                    ng-click="\$ctrl.removeUnit(\$index)"
                    class="btn btn-danger">
              Remove
            </button>
          </td>
        </tr>
        <tr ng-if="\$ctrl.actionButtonsEnabled()">
          <td colspan="7"></td>
          <td>
            <button type="button"
                    ng-click="\$ctrl.addNewUnit()"
                    class="btn btn-primary">
              Add
            </button>
          </td>
        </tr>
        </tbody>
        <tfoot class="transaction-create-footer">
        <tr>
          <td colspan="4">
            <label class="flex-end">Total</label>
          </td>
          <td>
            <cash value="\$ctrl.calculateDebitSum().toFixed(2)"
                  ng-disabled="true"></cash>
          </td>
          <td colspan="2">
            <cash value="\$ctrl.calculateCreditSum().toFixed(2)"
                  ng-disabled="true"></cash>
          </td>
          <td></td>
        </tr>
        </tfoot>
      </table>

      <div class="summary-actions">
        <button type="button"
                class="btn btn-warning"
                ng-click="\$ctrl.cancelChanges()">
          Cancel
        </button>
        <button type="button"
                class="btn btn-primary"
                ng-click="\$ctrl.submit()"
                ng-disabled="!\$ctrl.isFormValid()">
          Save
        </button>
        <button type="button"
                class="btn btn-success"
                ng-click="\$ctrl.print(\$event)"
                ng-disabled="!\$ctrl.canPrint()">
          Print
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/general-ledger/transactions/interbranch/gl-transaction-interbranch-create.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;